import CustomContainer from "./CustomContainer";
import ModalObj from "./ModalObj";

export default CustomContainer(ModalObj)